import * as React from 'react';
import { SpreadsheetResult } from './components/spreadsheet-result';
import { SpreadsheetType } from '@modules/spreadsheets/dto/spreadsheet/type';
import { SpreadsheetManagement } from './components/spreadsheet-management';

import './spreadsheet-details.styles.scss';

type SpreadsheetDetailsProps = {
  spreadsheetId: number;
  isRunSpreadsheet: boolean;
  isIndividual: boolean;
  initialFolderId?: number;
  initialFamilyId?: number;
};

export const SpreadsheetDetails: React.FC<SpreadsheetDetailsProps> = ({
  spreadsheetId,
  isIndividual,
  isRunSpreadsheet,
  initialFolderId,
  initialFamilyId,
}) => {
  if (!isRunSpreadsheet) {
    return (
      <div className="SpreadsheetDetails">
        <SpreadsheetManagement
          propsSpreadsheetId={spreadsheetId}
          spreadsheetType={isIndividual ? SpreadsheetType.individual : SpreadsheetType.pedigree}
          initialFolderId={initialFolderId}
          initialFamilyId={initialFamilyId}
        />
      </div>
    );
  }

  return (
    <div className="SpreadsheetDetails">
      <SpreadsheetResult
        spreadsheetId={spreadsheetId}
        spreadsheetType={isIndividual ? SpreadsheetType.individual : SpreadsheetType.pedigree}
        initialFolderId={initialFolderId}
        initialFamilyId={initialFamilyId}
      />
    </div>
  );
};